<script setup lang="ts">
definePageMeta({ middleware: 'guest' })

const { register } = useAuth()

const form = reactive({
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
})

const busy = ref(false)
const error = ref<string | null>(null)

async function submit(): Promise<void> {
    busy.value = true
    error.value = null

    try {
        await register({ ...form })
        await navigateTo('/home')
    } catch (err: unknown) {
        const body = (
            err as { data?: { message?: string; data?: { errors?: Record<string, string[]> } } }
        ).data
        const firstFieldError = body?.data?.errors
            ? Object.values(body.data.errors)[0]?.[0]
            : undefined

        error.value = firstFieldError ?? body?.message ?? 'Pendaftaran gagal. Semak maklumat anda.'
    } finally {
        busy.value = false
    }
}
</script>

<template>
    <div class="mx-auto max-w-md py-8">
        <div class="card !p-6">
            <p class="kicker">Akaun</p>
            <h1 class="mt-1 text-3xl font-bold tracking-tight">Daftar akaun</h1>
            <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Percuma je. Jom mula.</p>

            <form class="mt-6 space-y-4" @submit.prevent="submit">
                <div>
                    <label class="label" for="name">Nama</label>
                    <input
                        id="name"
                        v-model="form.name"
                        type="text"
                        class="input"
                        required
                        autocomplete="name"
                    >
                </div>

                <div>
                    <label class="label" for="email">Emel</label>
                    <input
                        id="email"
                        v-model="form.email"
                        type="email"
                        class="input"
                        required
                        autocomplete="email"
                    >
                </div>

                <div>
                    <label class="label" for="password">Kata laluan</label>
                    <input
                        id="password"
                        v-model="form.password"
                        type="password"
                        class="input"
                        required
                        minlength="8"
                        autocomplete="new-password"
                    >
                </div>

                <div>
                    <label class="label" for="password_confirmation">Sahkan kata laluan</label>
                    <input
                        id="password_confirmation"
                        v-model="form.password_confirmation"
                        type="password"
                        class="input"
                        required
                        autocomplete="new-password"
                    >
                </div>

                <p v-if="error" class="notice notice-danger" role="alert">{{ error }}</p>

                <button type="submit" class="btn-primary w-full" :disabled="busy">
                    {{ busy ? 'Mendaftar…' : 'Daftar' }}
                </button>
            </form>

            <p class="mt-5 text-sm">
                Dah ada akaun?
                <NuxtLink
                    to="/auth/login"
                    class="font-medium text-brand-600 hover:underline dark:text-brand-400"
                    >Log masuk</NuxtLink
                >
            </p>
        </div>
    </div>
</template>
